import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BrandIntroSection from "../components/home/BrandIntroSection";

import HomeUserPersonas from "../components/home/HomeUserPersonas";
import SupportSection from "@/components/home/SupportSection";
import AIFeature from "@/components/home/ai-feature";
import FutureMedicine from "@/components/home/FutureMedicine";
import HeroSection from "@/components/home/HomeHeroSection";
import ProductIntro from "@/components/home/ProductIntro";
import { motion } from "framer-motion";
import { watchData, ringData, bandData, trackerData, womenBandData, elderlyWatchData } from "@/components/home/product-intro/data";
import { Helmet } from "react-helmet-async";
import HealthLocationInnovation from "@/components/home/HealthLocationInnovation";

const HomePage: React.FC = () => {
    const ringSectionRef = useRef<HTMLDivElement>(null);
    const [triggerAnimation, setTriggerAnimation] = useState(0);

    // --- Structured Data ---
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Delband",
        url: "https://delband.com",
        logo: "https://delband.com/assets/logo.png",
        description: "Delband یک اکوسیستم سلامت دیجیتال نسل جدید (Med-3.0) است که با رینگ و مچ‌بند هوشمند، پایش مداوم سلامت و موقعیت‌یابی امن را فراهم می‌کند.",
        contactPoint: {
            "@type": "ContactPoint",
            telephone: "+98-21-9100XXXX",
            contactType: "Customer Support",
            areaServed: "IR",
        },
        sameAs: ["https://www.linkedin.com/company/delband", "https://instagram.com/delbandhealth", "https://x.com/delbandhealth"],
    };

    const scrollToProductComparison = () => {
        if (ringSectionRef.current) {
            ringSectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
            setTriggerAnimation((prev) => prev + 1);
        } else {
            const el = document.getElementById("rings-section");
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    };

    return (
        <>
            <Helmet>
                <title>دلبند | مراقب هوشمند سلامت و ایمنی خانواده</title>
                <meta
                    name="description"
                    content="دلبند، اکوسیستم سلامت هوشمند (Med-3.0) برای خانواده‌ها و سازمان‌هاست؛ شامل رینگ، مچ‌بند و ردیاب کودک با پایش مداوم علائم حیاتی، موقعیت‌یابی GPS و بینش‌های سلامت مبتنی بر هوش مصنوعی."
                />
                <meta
                    name="keywords"
                    content="دلبند, Delband, مراقب هوشمند, ردیاب کودک, رینگ هوشمند, مچ‌بند سلامت, سلامت دیجیتال, پایش سلامت, Med-3.0, هوش مصنوعی سلامت, سلامت سازمانی, GPS ایمنی, پوشیدنی هوشمند, ایران"
                />
                <link rel="canonical" href="https://delband.com/" />
                <meta property="og:title" content="دلبند | پلتفرم سلامت و ایمنی هوشمند خانواده" />
                <meta property="og:description" content="پایش مداوم علائم حیاتی، هشدارهای ایمنی و موقعیت‌یابی لحظه‌ای برای کودکان، سالمندان و کارکنان. دلبند، نسل نوین مراقبت هوشمند در ایران." />
                <meta property="og:image" content="https://delband.com/assets/og-image.jpg" />
                <meta property="og:url" content="https://delband.com/" />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Delband | مراقب هوشمند سلامت و ایمنی خانواده" />
                <meta name="twitter:description" content="دلبند، پلتفرم سلامت هوشمند با رینگ، مچ‌بند و ردیاب کودک برای پایش علائم حیاتی و هشدارهای ایمنی در لحظه." />
                <meta name="twitter:image" content="https://delband.com/assets/og-image.jpg" />
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <div className="min-h-screen bg-[#F8F9FC]">
                <Header />
                <main id="main-content" className="relative">
                    {/* <div className="absolute bottom-0 left-0 w-full h-[300px] bg-gradient-to-r from-[#A44302] to-[#F86300] rounded-full blur-[120px] opacity-15 sm:opacity-25 z-[999999] pointer-events-none"></div> */}
                    <div className="bg-gradient-to-b from-[#E0EDFF] to-transparent relative overflow-hidden">
                        <div className="mx-auto px-2 pb-8 pt-24 sm:pt-24 md:pt-21">
                            <HeroSection onCompareClick={scrollToProductComparison} />
                        </div>
                    </div>

                    <div className="container mx-auto px-2 pb-8 max-w-7xl">
                        {/* <TrustedBySection /> */}
                        {/* <AboutBrand /> */}
                        <BrandIntroSection />
                        <div ref={ringSectionRef} id="rings-section" className="scroll-mt-24">
                            <ProductIntro data={ringData} />
                        </div>
                        {/* <ProductIntro data={watchData} /> */}
                        <ProductIntro data={womenBandData} />
                        <ProductIntro data={bandData} />
                        {/* <ProductIntro data={trackerData} /> */}
                        <ProductIntro data={elderlyWatchData} />

                        <AIFeature />
                        <FutureMedicine />
                        <HealthLocationInnovation />
                        {/* <HomeHowItWorks /> */}

                        <HomeUserPersonas />

                        <SupportSection />
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default HomePage;
